export default {
  withdrawableBalanceText: 'dt.payments.components.withdrawableBalanceText',
};
